import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { CommonDataSource } from '@app/workflow-common/services/CommonDataSource';

@Component({
    selector: 'app-cs-search-bar',
    templateUrl: './cs-search-bar.component.html',
    styleUrls: ['cs-search-bar.component.scss']
})
export class CsSearchBarComponent implements OnInit {

    @Input() placeHolder = 'Search';
    @Input() searchText = ''; // Note: Use this for clear the searched text from parent component
    @Input() isHideClearBtn = false;
    @Input() showUserListDropDown = false;
    usersList: any[] = [];
    filteredUsers: string[] = [];
    showSearchDropdown: boolean = false;
    timeDelay: any = "";
    searchInputValue: string = '';

    @Output() onItemSearch = new EventEmitter<any>();


    constructor() {
    }

    async ngOnInit() {
        // await CommonDataSource.getUserData();
        // if (CommonDataSource.userData['userRecords']) {
        //     this.usersList = CommonDataSource.userData['userRecords'];
        // }
        await CommonDataSource.getUserData();
        if (CommonDataSource.userData['userRecords']) {
            this.usersList = CommonDataSource.userData['userRecords'].map(user => ({
                ...user, selected: false
            }));
        }
    }

    searchItem(e) {
        this.searchText = e;
        if (this.showUserListDropDown) {
            const data = {
                searchText: this.searchText,
            };
            this.onItemSearch.emit(data);
        } else {
            this.onItemSearch.emit(this.searchText);
        }
    }

    onSearch(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
        const text = event.target.value;
        const atIndex = text.lastIndexOf('@');
        if (atIndex !== -1 && atIndex !== text.length - 1) {
            const regex = /@(\w+)/;
            const match = text.match(regex);
            if (match) {
                const searchText = match[1];
                this.filteredUsers = this.usersList.filter((user) =>
                    user.name.toLowerCase().includes(searchText.toLowerCase()) && (!user.hasOwnProperty('selected') || !user.selected)
                );
                this.showSearchDropdown = !!searchText && this.filteredUsers.length > 0;
            } else {
                this.showSearchDropdown = false;
            }
        }
        else if (atIndex === -1) {
            let _self = this;
            clearTimeout(this.timeDelay);
            this.timeDelay = setTimeout(() => {
                _self.getSearchedValue();
            }, 1000);
        }
    }

    removeUser(user) {
        user.selected = false;
        this.getSearchedValue();
    }

    searchLeave() {
        setTimeout(() => {
            this.showSearchDropdown = false;
            if (this.searchInputValue) {
                const regex = /@(\w+)/;
                this.searchInputValue = this.searchInputValue.replace(regex, '')
            }
        }, 300);
    }

    getSearchedValue() {
        const data = {
            userId: this.getSelectedUserId(),
            searchText: this.searchInputValue,
        };
        this.onItemSearch.emit(data);
    }

    getSelectedUserId() {
        if (!this.usersList || !Array.isArray(this.usersList)) {
            return '';
        }

        let users = this.usersList
            .filter(user => user.selected)
            .map(user => user.id);

        return users.join(',');
    }


    selectUser(user) {
        user.selected = true;
        this.showSearchDropdown = false;
        setTimeout(() => {
            this.getSearchedValue();
        }, 350);
    }

    clearSearch() {
        this.searchText = '';
        this.onItemSearch.emit(this.searchText);
    }

    clearSearchValue() {
        if (this.showUserListDropDown) {
            this.searchInputValue = '';
            this.usersList = this.usersList.map(user => ({...user, selected: false}));
            this.getSearchedValue();
        } else {
            this.searchInputValue = '';
        }
    }

    resetInput() {
        this.usersList = this.usersList.map(user => ({...user, selected: false}));
        this.searchInputValue = '';
    }


}
